import { env } from '../env';

function getAppData(appName) {
  return ((env().fedops || {}).apps || {})[appName];
}

export function initializeFedops() {
  env().fedops = env().fedops || {};
  env().fedops.apps = env().fedops.apps || {};
}
export function initializeApp(appName) {
  env().fedops.apps[appName] = env().fedops.apps[appName] || {};
}
export function initializeGlobal(appName) {
  initializeFedops();
  initializeApp(appName);
}
export function getLoadStartTime(appName) {
  return (getAppData(appName) || {}).startLoadTime || 0;
}
export function setLoadStartTime(appName, startLoadTime) {
  return (getAppData(appName) || {}).startLoadTime = startLoadTime;
}
export function setSessionId(sessionId) {
  return (env().fedops || {}).sessionId = sessionId;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/fedops-logger/dist/es/src/global-app-data/global-app-data.js
// module id = 83
// module chunks = 0 1